import '../styles/progress-loader.scss';

export const ProgressLoader = () => {
    return (
        <div className="progressLoader"></div>
    )
}